import type { AxiosInstance } from 'axios';
import type { Branding } from './interfaces/groups';
import type * as Groups from './interfaces/groups';

export class GroupsClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  getGroupUsers = (data: Groups.GetGroupUsers.Request): Promise<Groups.GetGroupUsers.Response> => {
    return this.authenticatedClient.get<Groups.GetGroupUsers.Response>(`/groups/users`, { params: data }).then(res => res.data);
  };

  fetchBranding = (data: Branding.FetchBranding.Request) => {
    return this.authenticatedClient.get<Branding.FetchBranding.Response>(`/groups/${data.groupId}/branding`)
      .then(res => res.data);
  };
}